import React, { Component } from 'react';
import styles from './ToolbarGroup.module.scss';

class ToolbarGroup extends Component {
  render() {
    const { children } = this.props;

    return <div className={styles['wrapper']}>{children}</div>;
  }
}

export default ToolbarGroup;
